export default "__VITE_ASSET__CpOQ0eWj__"